// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UUuD7","question":"styles_question__3GrIx","description":"styles_description__bJnwP"};